import * as TYPES from './constants';
import {
  receiveUserPermissionList,
  requestUserPermissionList,
  handleUserPermissionError,
} from './actions';

import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';

const initialState = {
  userPermissions: null,
  request: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_USER_PERMISSION_LIST:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_USER_PERMISSION_LIST:
      return {
        ...state,
        userPermissions: action.payload,
        request: false,
        error: false,
      };
    case TYPES.USER_PERMISSION_LIST_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchUserPermissionList = () => (dispatch, getState) => {
  const state = getState();
  let accessToken = null;
  if (state && state.auth && state.auth.access) {
    const {
      auth: {
        access: {token},
      },
    } = state;
    accessToken = token;
  }

  if (accessToken) {
    const config = {
      method: 'GET',
      mode: 'cors',
      headers: Object.assign({}, JWT_HEADER(accessToken), JSON_HEADER),
      cache: 'default',
    };
    dispatch(requestUserPermissionList());
    try {
      return fetch(`${API.srm.user_type_premission}`, config)
        .then(response => response.json())
        .then(json => {
          dispatch(receiveUserPermissionList(json));
        })
        .catch(err => {
          console.log(err);
          dispatch(handleUserPermissionError(err));
        });
    } catch (err) {
      console.log(err);
      dispatch(handleUserPermissionError(err));
    }
  }
};
